<div class="modal-header d-flex flex-column">
    <h2 class="modal-title">{{ modalTitleTranslationKey | translate }}</h2>
    <button
        type="button"
        data-uit="close-modal"
        class="btn ca-btn-icon ca-btn-icon-big modal-button-close"
        (click)="dismiss()"
        [title]="'GENERAL.CLOSE' | translate"
    >
        <ca-icon name="cross" size="l"></ca-icon>
    </button>
</div>
<div class="modal-body" data-uit="MED-upload-dialog-modal-body">
    <div class="row">
        <ng-container *ngTemplateOutlet="selectedFilesSection"></ng-container>
    </div>
</div>
<div class="modal-footer modal-buttons direction-column">
    <button type="button" class="btn btn-secondary w-100 me-1" data-uit="file-upload-btn" (click)="uploadSection.click()">
        <ng-container>
            {{ 'UPLOAD_MED_FILES_DIALOG.ADD_FILES' | translate }}
        </ng-container>
        <input #uploadSection type="file" data-uit="file-upload-input" ng2FileSelect [uploader]="uploader" [multiple]="true" hidden />
    </button>
    <button type="submit" class="btn btn-primary w-100" [disabled]="!isUploading" caAutoFocus data-uit="start-btn" (click)="uploadFiles(selectedFiles)">
        {{ uploadButtonTranslationKey | translate }}
    </button>
</div>
<ng-template #selectedFilesSection>
    <form autocomplete="off" data-uit="selected-files-section" class="selected-files-form">
        <div class="row">
            <div class="col mb-3">
                <div data-uit="uploaded-files-msg-run-name" class="d-flex text-nowrap">
                    <span class="text-pale ps-1">{{ 'UPLOAD_MED_FILES_DIALOG.UPLOADED_DATA_MESSAGE' | translate }}</span
                    >&nbsp;
                    <ng-container *ngIf="parentFolderName">
                        <div>
                            {{ buildBreadcrumbString(breadcrumbs) }}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="row selected-files-row">
            <div class="col">
                <ca-selected-files
                    caApeerFileUpload
                    data-uit="selected-files"
                    [isMedCZIConversionDisabled]="true"
                    [operationId]="operationId"
                    [columns]="columns"
                    [actions]="actions"
                    [isUploadOfFilesEnabled]="isUploadOfFilesEnabled"
                    [isResetButtonShown]="!isMEDprojectEnabled"
                    [selectedFiles]="selectedFiles"
                    [uploaderKey]="UPLOADER_KEY.MY_FILES_UPLOAD_UPLOADER_KEY"
                    [targetFolderToBeCreated]="targetFolderToBeCreated"
                    [currentFolderid]="currentFolderId"
                    [allowDragAndDrop]="isMEDprojectEnabled"
                    (filesAdded)="addedFiles($event)"
                    (changeStudyId)="onChangeStudyId($event)"
                    (changeCustomTags)="onChangeCustomTags($event)"
                    (removeTag)="onTagRemoved($event)"
                    (selectedFilesUpdated)="onSelectedFilesUpdated($event)"
                    (removeItems)="removeFiles.emit($event)"
                ></ca-selected-files>
            </div>
        </div>
    </form>
</ng-template>
